import { QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { DEFAULT_RETRY_COUNT } from '@/shared/config';

const QUERY_CACHE_STORAGE_KEY = 'F2EX_QUERY_CLIENT_LOCAL_CACHE';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: DEFAULT_RETRY_COUNT,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const asyncStoragePersister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: QUERY_CACHE_STORAGE_KEY,
});

export const clearQueryCacheOnLogout = async (): Promise<void> => {
  await queryClient.cancelQueries();
  queryClient.clear();
  await asyncStoragePersister.removeClient();
};
